import { AGENT_NAME } from '../constants/variables';
import { getLSwithTime, setLSwithTime } from '../storage/LocalStorage';

const ONE_WEEK_SEC = 604800;

export const setupAgentParam = (agent?: string) => {
    if (!agent) {
        return;
    }

    const oldParam = getLSwithTime(AGENT_NAME);

    if (agent === oldParam) {
        return;
    }

    setLSwithTime(AGENT_NAME, agent, ONE_WEEK_SEC);
};
